import { CommandBar } from "@fluentui/react";
import { Badge, Descriptions, Divider, Drawer, Skeleton } from "antd";
import QuaiboDailyProductionStore from "../../store/quaibodailyproductionstore";

import { observer } from "mobx-react-lite";
import React, { createContext, useContext } from "react";
import { Printer } from "react-feather";
import RequestStore from "../store/requeststore";
import moment from "moment";
import formatNumber from "accounting-js/lib/formatNumber";
import { Printd } from 'printd'
import renderHTML from "react-render-html";
const requestStoreCtx = createContext(RequestStore);
const QuaiboStoreCtx = createContext(QuaiboDailyProductionStore);
export const QuaiboDailyproductionDetails = observer(() => {
  const quaiboDailyProductionStore = useContext(QuaiboStoreCtx);
  const requestStore = useContext(requestStoreCtx);
  return (
    <Drawer
      title={`Quaibo Daily Production Details`}
      placement="right"
      width={"60%"}
      closable={true}
      destroyOnClose={true}
      onClose={() => {
        requestStore.showQuaiboProductionDetailDialog = false;
      }}
      visible={requestStore.showQuaiboProductionDetailDialog}
    >
      {quaiboDailyProductionStore.isLoadingDailyProd ? (
        <>
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
          <Skeleton active />
        </>
      ) : (
        <>
         <div id="printPane">
          <Badge.Ribbon
            text={quaiboDailyProductionStore.initFormaData.status}
            placement="start"
            color={
              quaiboDailyProductionStore.initFormaData.approvalStatus === 1
                ? "gold"
                : quaiboDailyProductionStore.initFormaData.approvalStatus === 2
                ? "#87d068"
                : quaiboDailyProductionStore.initFormaData.approvalStatus === 3
                ? "#f50"
                : "#d9d9d9"
            }
          >
            <CommandBar
              farItems={[
                {
                  key: "print",
                  text: "Print",
                  onRenderIcon: () => <Printer className="qicon" />,
                  onClick:()=>{
                    const d=new Printd();
                    d.print( document.getElementById('printPane'), [] )
                  }
                },
              ]}
            />
          </Badge.Ribbon>
          <Divider>{`${
            quaiboDailyProductionStore.IsEquityProduction === 0
              ? "QUAIBO JV GROSS"
              : "QUAIBO EQUITY SHARE"
          } PRODUCTION FIGURES @ ${moment(
            quaiboDailyProductionStore.initFormaData.productionDate
          ).format(" dddd, Do MMMM YYYY")}`}</Divider>
          <Descriptions
            title={"Production Figures"}
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="Gross Crude Production To Storage Tank (BOPD)">
              {formatNumber(quaiboDailyProductionStore.initFormaData.blpd, {
                precision: 2,
                thousand: ",",
              })}
            </Descriptions.Item>
            <Descriptions.Item label="Net Crude Production  (bbl.) ">
              {formatNumber(quaiboDailyProductionStore.initFormaData.oil, {
                precision: 2,
                thousand: ",",
              })}
            </Descriptions.Item>
            <Descriptions.Item label="Field Water Production (bbl.)">
              {formatNumber(quaiboDailyProductionStore.initFormaData.water, {
                precision: 2,
                thousand: ",",
              })}
            </Descriptions.Item>

            <Descriptions.Item label="Condensate from Gas Plant (bopd)">
              {formatNumber(
                quaiboDailyProductionStore.initFormaData.condensate,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>

            <Descriptions.Item label="Daily Gas Production (Mmscf)">
              {formatNumber(quaiboDailyProductionStore.initFormaData.gas, {
                precision: 2,
                thousand: ",",
              })}
            </Descriptions.Item>
            <Descriptions.Item label="Fuel Gas Consumed in Operations (Mmscfd)">
              {formatNumber(quaiboDailyProductionStore.initFormaData.fuelGas, {
                precision: 2,
                thousand: ",",
              })}
            </Descriptions.Item>
            <Descriptions.Item label="Utilized Gas (Mmscf/d)">
              {formatNumber(
                quaiboDailyProductionStore.initFormaData.ownUseGas,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>

            <Descriptions.Item label="Flared Gas (Mmscfd)">
              {formatNumber(quaiboDailyProductionStore.initFormaData.flareGas, {
                precision: 2,
                thousand: ",",
              })}
            </Descriptions.Item>
          </Descriptions>
          <Descriptions
            title={<div>Evacuation Figures</div>}
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="Crude Injection to GGF (bbl.) GIV.">
              {formatNumber(
                quaiboDailyProductionStore.initFormaData.crudeInjectionGGF,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Drained water from ABJ 400 & 500 (bbl.)">
              {formatNumber(
                quaiboDailyProductionStore.initFormaData.drainedWater,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
            <Descriptions.Item label="Evacuated Gas (Mmscf/d)">
              {formatNumber(
                quaiboDailyProductionStore.initFormaData.evacuatedGas,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>

            <Descriptions.Item label="Evacuation Uptime (hrs)">
              {quaiboDailyProductionStore.initFormaData.evacuationUptime}
            </Descriptions.Item>
            <Descriptions.Item label="Evacuated Condensate(bopd)">
              {formatNumber(
                quaiboDailyProductionStore.initFormaData.evacuatedCondensate,
                {
                  precision: 2,
                  thousand: ",",
                }
              )}
            </Descriptions.Item>
          </Descriptions>

          <Descriptions
            title={<div>Other Station Figures</div>}
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="Operating Hrs.">
              {quaiboDailyProductionStore.initFormaData.operatingHrs}
            </Descriptions.Item>
            <Descriptions.Item label="Produced Oil Gravity °API @ 60">
              {quaiboDailyProductionStore.initFormaData.stationAPI}
            </Descriptions.Item>

            <Descriptions.Item label="Station BS&W (%)">
              {quaiboDailyProductionStore.initFormaData.bsw}
            </Descriptions.Item>
            <Descriptions.Item label="GOR(scf/bbl.)">
              {quaiboDailyProductionStore.initFormaData.gor}
            </Descriptions.Item>
          </Descriptions>

          <Descriptions
            title="PRODUCTION REMARKS"
            size={"small"}
            bordered
            labelStyle={{ fontWeight: "bold" }}
          >
            <Descriptions.Item label="QUAIBO DAILY  PRODUCTION REMARKS">
              {quaiboDailyProductionStore.initFormaData.remarks &&
                renderHTML(quaiboDailyProductionStore.initFormaData.remarks)}
            </Descriptions.Item>
          </Descriptions>

          {quaiboDailyProductionStore.initFormaData.approvalStatus === 2 && (
            <Descriptions
              title="PRODUCTION APPROVAL "
              size={"small"}
              bordered
              labelStyle={{ fontWeight: "bold" }}
            >
              <Descriptions.Item label="Approved On">
                {moment(
                  quaiboDailyProductionStore.initFormaData.approvedDate
                ).format("LLLL")}
              </Descriptions.Item>
              <Descriptions.Item label="Approver">
                {quaiboDailyProductionStore.initFormaData.approver}
              </Descriptions.Item>
              <Descriptions.Item label="Approver Remarks">
                {quaiboDailyProductionStore.initFormaData.approverComment}
              </Descriptions.Item>
            </Descriptions>
          )}
          </div>
        </>
      )}
    </Drawer>
  );
});

